module.exports = __webpack_public_path__ + "static/media/29nicedeck2.af89c36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/29nicedeck2.png
// module id = 124
// module chunks = 0